import { ReactNode } from "react"

export function FormatRulesSection(props: {
    title: string,
    children: ReactNode,
    className?: string
}) {
    return (
        <div className={props.className}>
            <div className="flex items-center gap-x-4">
                <h4 className="flex-none text-sm font-semibold leading-6 text-emphasis">{props.title}</h4>
                <div className="h-px flex-auto bg-contrast-tertiary" />
            </div>
            {
                !!props.children &&
                props.children
            }
        </div>
    )
}